
// Import module styles.
import "./welcome.view.less";
